<template>
  <div style="min-width: 1000px">
    <div class="header">
      <Header></Header>
    </div>
    <div class="content">
      <div :style="{'width': collapsed?'150px':'44px'}" style="height: 100%">
        <Sidebar></Sidebar>
      </div>
      <div class="container" :style="[{position: 'relative','width': collapsed?'calc(100% - 150px)':'calc(100% - 44px)'}]">
        <a-breadcrumb v-if="$route.path!='/dashboard' && $route.path!='/logs'" :separator-icon="ArrowRight" class="breadcrumb" separator="/">
          <a-breadcrumb-item :key="item.path" v-for="item in tabs" class="cursor-pointer"  @click="$router.push(item.path)" :to="tabFirst.path">
                        {{ $t(item.meta.title) }}
          </a-breadcrumb-item>
        </a-breadcrumb>

          <router-view  v-if="$route.meta.keepAlive" v-slot="{ Component }">
            <KeepAlive >
              <component :is="Component" />
            </KeepAlive>
          </router-view>

        <router-view v-else v-slot="{ Component }">
            <component :is="Component" />
        </router-view>


        <!--            v-if="$route.meta.keepAlive"-->
        <!--              <component v-else :is="Component" />-->


      </div>
    </div>
  </div>
</template>
<script>
import { computed,ref,watch } from "vue";
import { useStore } from "vuex";
import { useRoute,useRouter } from "vue-router";
import Header from "../components/Header.vue";
import Sidebar from "../components/Sidebar.vue";
import Tags from "../components/Tags.vue";
import i18n from "@/locales/setupI18n";
export default {
  components: {
    Header,
    Sidebar,
    Tags
  },
  // 327+153 480
  setup() {
    const {t} = i18n.global;

    const store = useStore();
    const $route = useRoute();
    const $router = useRouter();
    const collapsed = computed(() => store.state.collapse);

    const tagsList = computed(() =>
        store.state.tagsList.map((item) => item.name)
    );
    const tabFirst = ref({
      path:'/dashboard',
      meta:{
        title:'首页'
      }
    })
    const tabs = ref([])
    const getBreadCom = () => {
      store.commit('setFullPath',$route.fullPath)

      let mached = $route.matched.filter((item) => item.meta.title)
      // 第一个路径如果不是首页，需要在匹配路径前面拼接一个首页
      const first = mached[0];
      let tab = first.meta.tab;
      let parent = first.meta.parent;
      console.log(first);
      if(parent != null){
        let fullPath = parent.fullPath;
        let title = parent.title;
        store.commit('setFullPath',fullPath)
        first.meta.title = store.state.titleText;
        mached = [{ path: fullPath,meta: {title: title}}].concat(mached)
      }




      if(tab == null || !tab ) {
        mached = [{ path: '/logs',meta: {title: '首页'}}].concat(mached)
      }
      tabs.value = mached;
    }
    getBreadCom();
    watch(() =>$route.path,() => getBreadCom())
    return {
      tagsList,
      collapsed,
      getBreadCom,
      tabs,
      tabFirst,
      $router
    };
  },
};
</script>
<style scoped lang="less">
.content{
  display: flex;
  height: calc(100vh - 45px);
}
.cursor-pointer{
  cursor: pointer;
}
.breadcrumb{
  margin: 10px 20px;
}

</style>
